<template>
  <div id="app">
    <router-view />
    <!-- 棉花炭疽病信息展示弹窗 -->
    <div v-if="showCottonInfo" class="disease-modal" @click="closeCottonInfo">
      <div class="disease-content" @click.stop>
        <div class="disease-header">
          <h2>{{ $t('app.cottonModal.title') }}</h2>
          <span class="probability">{{ $t('app.cottonModal.probability') }}</span>
          <button class="close-btn" @click="closeCottonInfo">×</button>
        </div>
        <div class="disease-body">
          <div class="feature-section">
            <h3>{{ $t('app.cottonModal.featureTitle') }}</h3>
            <p>{{ $t('app.cottonModal.feature') }}</p>
          </div>
          <div class="prevention-section">
            <h3>{{ $t('app.cottonModal.preventionTitle') }}</h3>
            <div class="method-item">
              <h4>{{ $t('result.physical') }}</h4>
              <div class="method-content" v-html="$t('app.cottonModal.physics')"></div>
            </div>
            <div class="method-item">
              <h4>{{ $t('result.chemical') }}</h4>
              <div class="method-content" v-html="$t('app.cottonModal.chemistry')"></div>
            </div>
            <div class="method-item">
              <h4>{{ $t('result.biological') }}</h4>
              <div class="method-content" v-html="$t('app.cottonModal.biology')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      showCottonInfo: false
    }
  },
  methods: {
    showCottonDiseaseInfo() {
      this.showCottonInfo = true;
    },
    closeCottonInfo() {
      this.showCottonInfo = false;
    }
  },
  mounted() {
    // 监听来自子组件的棉花点击事件
    this.$root.$on('cottonClicked', this.showCottonDiseaseInfo);
  },
  beforeDestroy() {
    this.$root.$off('cottonClicked', this.showCottonDiseaseInfo);
  }
}
</script>

<style>
@import 'assets/styles/main.scss';

#app {
  font-family: "PingFangSC", "PingFang SC", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* 棉花炭疽病弹窗样式 */
.disease-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.disease-content {
  background: white;
  border-radius: 12px;
  max-width: 600px;
  max-height: 80vh;
  width: 90%;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.disease-header {
  background: linear-gradient(135deg, #4CAF50, #45a049);
  color: white;
  padding: 20px;
  border-radius: 12px 12px 0 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.disease-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.probability {
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.disease-body {
  padding: 25px;
}

.feature-section {
  margin-bottom: 25px;
}

.feature-section h3 {
  color: #2c3e50;
  margin: 0 0 15px 0;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 2px solid #4CAF50;
  padding-bottom: 8px;
}

.feature-section p {
  color: #555;
  line-height: 1.6;
  margin: 0;
  text-align: left;
}

.prevention-section h3 {
  color: #2c3e50;
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 2px solid #4CAF50;
  padding-bottom: 8px;
}

.method-item {
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.method-item h4 {
  background: #f5f5f5;
  margin: 0;
  padding: 12px 15px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
}

.method-content {
  padding: 15px;
  text-align: left;
  line-height: 1.6;
  color: #555;
}

.method-content ::v-deep br {
  margin-bottom: 8px;
}
</style>